import {FC} from 'react'
import {TableCancellationsChangesWrapper} from '../components/Tables/TableCancellationsChanges'

const HeaderCancellationsPanel: FC = () => {
  return (
    <>
      <TableCancellationsChangesWrapper />
    </>
  )
}

export {HeaderCancellationsPanel}
